import country from "fragments/vendors/country"
import { gql } from "graphql-tag"

const GET_COUNTRIES_WAVE = gql`
  ${country}

  query getCountriesWave($query: GetWaveQueryCountries) {
    getCountriesWave(query: $query) {
      countries {
        ...Country
      }
      cursor
      hasPrevData
      hasNextData
      prevCursor
    }
  }
`

export default GET_COUNTRIES_WAVE
